/**
 * @desc        Notification Actions
 * @version     1.1.1 (Added entities listener to piggyback off of the notifications listener) - 27 May 2026
 * */

import { startOfMonth, subMonths } from 'date-fns'
import { addNotificationListener, arcNotification, deleteMultipleNotifications, redNotification } from 'services/firebase/firebaseDb.js'
import * as actionTypes from '../action-types.js'
import { subscribeAutomationFirestore, unsubscribeAutomationFirestore } from './automation-actions.js'

let notificationListener, deviceNotificationListener

export const getNotifications = payload => {
    return async (dispatch, getState) => {
        const username = getState()?.aws?.data?.username
        const tenant = payload?.tenant

        // console.log('getNtofications', username, tenant)

        // TODO - come back to this after
        // if (tenant !== '*') {
        //     if (deviceNotificationListener) removeDeviceNotificationListener()

        //     deviceNotificationListener = addSensorsCollectionListener(tenant, (sensors) => {
        //         console.log('Sensors updated:', sensors)
        //         dispatch({
        //             type: actionTypes.FD_DEVNOTIFICATIONS_SET,
        //             data: sensors,
        //         })
        //     })
        // }

        if (username && tenant) {
            unsubscribeNotifications()

            await deleteMultipleNotifications(username)

            notificationListener = addNotificationListener(snapshot => {
                const records = snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data(),
                }))
                // console.log(records)
                const oneMonthAgo = startOfMonth(subMonths(new Date(), 4)).getTime()
                const filteredRecords = records.filter(record => record.timestamp >= oneMonthAgo)

                // console.log(filteredRecords)

                dispatch({
                    type: actionTypes.FD_NOTIFICATIONS_SET,
                    data: filteredRecords,
                })
            }, username)

            dispatch(subscribeAutomationFirestore(tenant))
        } else {
            return Promise.reject('no username')
        }
    }
}

export const archiveNotification = docId => {
    return async (dispatch, getState) => {
        const username = getState()?.aws?.data?.username
        if (username) {
            arcNotification({ docId: docId, userName: username })
        }
        return Promise.resolve('')
    }
}
export const readNotification = docId => {
    return async (dispatch, getState) => {
        const username = getState()?.aws?.data?.username
        if (username) {
            redNotification({ docId: docId, userName: username })
        }
        return Promise.resolve('')
    }
}

export const unsubscribeNotifications = () => {
    if (notificationListener) {
        notificationListener()
        notificationListener = null
    }
    unsubscribeAutomationFirestore()
}
